module.exports = __webpack_public_path__ + "img/deal-icon.70fc4112.svg";